import type { RouteRecordRaw } from 'vue-router';

import getMonitorForDevelopersRoutes from '@/features/monitor/developer/getMonitorForDevelopersRoutes';

const MonitorPage = async () => import('@/pages/MonitorPage.vue');

export default function getMonitorRoutes(): RouteRecordRaw[] {
  return [
    {
      name: 'monitor',
      component: MonitorPage,
      path: '/monitor',
    },
    ...getMonitorForDevelopersRoutes(),
  ];
}
